import { render } from "./EmpresasView.vue?vue&type=template&id=d28fe93c"
import script from "./EmpresasView.vue?vue&type=script&lang=js"
export * from "./EmpresasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__